/**
 * @generated SignedSource<<b5f5fc2b314adffc8928163d18f02f9b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowMaybeWithDragAndDrop_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowInner_rules" | "RowWithDragAndDrop_rules">;
  readonly " $fragmentType": "RowMaybeWithDragAndDrop_rules";
};
export type RowMaybeWithDragAndDrop_rules$key = {
  readonly " $data"?: RowMaybeWithDragAndDrop_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RowMaybeWithDragAndDrop_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RowWithDragAndDrop_rules"
    },
    {
      "kind": "FragmentSpread",
      "name": "RowInner_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "08b9aeb323501268f81c92713a749c54";

export default node;
